import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import "leaflet/dist/leaflet.css";
import "./GNSSOverview.css";
import { AirportMarker } from "components";

import { Col } from "react-bootstrap";
import { MapContainer, TileLayer, useMap, useMapEvents } from "react-leaflet";

import { useGnssApi, useAuth, useFilter } from "utils/hooks";

import { jwtDecode } from "jwt-decode";

export const GNSSLocations = () => {
  const api = useGnssApi();
  const { groupFilter } = useFilter();

  const [successRequest, setSuccessRequest] = useState(false);
  const [stations, setStations] = useState([]);
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState([45, 25]);
  const [zoom, setZoom] = useState(7);

  const [offset, setOffset] = useState(1);

  const [hideLegend, setHideLegend] = useState(false);
  var mapRef = useRef();

  var countries = [
    { name: "RO", center: [25.0094303, 45.9442858] },
    { name: "AU", center: [14.5162, 47.5501] },
  ];
  const { tenant_access_token, onLogout } = useAuth();
  useEffect(() => {
    if (
      tenant_access_token &&
      jwtDecode(tenant_access_token).active_tenant ===
        "c0a80a8b-9589-17bd-8195-89682cd60000"
    )
      setCenter(countries[1].center.reverse());
    else setCenter(countries[0].center.reverse());
  }, [tenant_access_token]);

  const centerMap = () => {
    if (window.innerWidth < 576) {
      mapRef.current.setView(center, 6);
      setHideLegend(true);
    }
    if (576 <= window.innerWidth && window.innerWidth < 768) {
      mapRef.current.setView(center, 6);
      setHideLegend(true);
    }
    if (768 <= window.innerWidth && window.innerWidth < 992) {
      mapRef.current.setView(center, 7);
      setHideLegend(false);
    }
    if (992 <= window.innerWidth && window.innerWidth < 1200) {
      mapRef.current.setView(center, 7);
      setHideLegend(false);
    }

    if (1200 <= window.innerWidth) {
      mapRef.current.setView(center, 7);
      setHideLegend(false);
    }
  };

  useLayoutEffect(() => {
    function updateSize(e) {
      if (mapRef.current == null) return;

      centerMap();
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const getStationsDetails = async () => {
    try {
      let response = await api.getAllStationsDetails();
      response = response.data;
      response = response.filter((station) =>
        station.groupNames.some(
          (groupName) => !groupFilter.includes(groupName),
        ),
      );

      setSuccessRequest(true);
      setStations(response ?? []);
      return response;
    } catch (e) {
      setSuccessRequest(false);
      setStations([]);
    }
  };

  useEffect(() => {
    getStationsDetails();
  }, []);

  useEffect(() => {
    mapRef.current = map;
    if (map != null) centerMap();
  }, [map]);

  function MyComponent() {
    const mapInstance = useMap();

    useEffect(() => {
      setMap(mapInstance);
    }, [mapInstance]);

    useMapEvents({
      zoomend: () => {
        if (mapInstance.getZoom() <= 6) setOffset(6);
        else setOffset(mapInstance.getZoom());
      },
    });

    return <></>;
  }

  return (
    <>
      <Col>
        <MapContainer
          style={{ height: "calc(100vh - 56px)" }}
          center={[46, 25]}
          zoom={7}
          scrollWheelZoom={true}
        >
          <MyComponent />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {successRequest && stations !== null
            ? stations?.map((airport, index) => {
                return (
                  <AirportMarker
                    key={index}
                    zoom={offset}
                    details={airport}
                    map={map}
                  />
                );
              })
            : null}
        </MapContainer>
      </Col>
    </>
  );
};
